import { Skeleton } from "@website/ui/skeleton";
import dynamic from "next/dynamic";

export const Mapbox = dynamic(
  () => import("./mapbox").then(({ Mapbox }) => Mapbox),
  {
    ssr: false,
    loading: () => <Skeleton className="size-full" />
  }
);

export * from "./mapbox.types";
